import React, { useEffect, useRef, useState } from "react";
import { changePasswordApi } from "./agentService";

const ChangePassword = ({ employeeId, mobile }) => {
  const [formData, setFormData] = useState({
    mobile: mobile,
    newPassword: "",
  });

  const [errors, setErrors] = useState({});
  const closeModalRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.mobile || !formData.newPassword) {
      setErrors({
        mobile: formData.mobile ? "" : "Mobile Number is mandatory",
        newPassword: formData.newPassword ? "" : "New Password is mandatory",
      });
      return;
    }

    try {
      await changePasswordApi(formData);

      setFormData({
        mobile: mobile,
        newPassword: "",
      });

      setErrors({});

      closeModalRef.current?.click();
    } catch (err) {
      console.log("Error in Change Password", err);
    }
  };
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      mobile: mobile || "",
    }));
  }, [mobile]);

  return (
    <>
      <div
        className="modal fade"
        id={`changePasswordModal${employeeId}`}
        tabIndex={-1}
        role="dialog"
        aria-labelledby="changeAgentLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="changeAgentLabel">
                Change Agent Password
              </h5>

              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <i aria-hidden="true" className="ki ki-close" />
              </button>
            </div>

            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-md-12 mb-5">
                    <label className="form-label">
                      Mobile
                      <span className="text-danger font-size-xs">*</span>
                    </label>

                    <input
                      type="text"
                      className={`form-control`}
                      //   className={`form-control ${
                      //     errors?.mobile ? "invalid" : ""
                      //   }`}
                      value={formData.mobile}
                      disabled
                      //   onChange={(e) => {
                      //     setFormData({
                      //       ...formData,
                      //       mobile: e.target.value,
                      //     });

                      //     setErrors({
                      //       ...errors,
                      //       mobile: e.target.value
                      //         ? ""
                      //         : "Mobile Number is mandatory",
                      //     });
                      //   }}
                    />

                    <p className="text-danger font-size-xs m-0">
                      {errors?.mobile}
                    </p>
                  </div>

                  <div className="col-md-12 mb-3">
                    <label className="form-label">
                      New Password
                      <span className="text-danger font-size-xs">*</span>
                    </label>

                    <input
                      type="password"
                      className={`form-control ${
                        errors?.newPassword ? "invalid" : ""
                      }`}
                      value={formData.newPassword}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          newPassword: e.target.value,
                        });

                        setErrors({
                          ...errors,
                          newPassword: e.target.value
                            ? ""
                            : "New Password is mandatory",
                        });
                      }}
                    />

                    <p className="text-danger font-size-xs m-0">
                      {errors?.newPassword}
                    </p>
                  </div>
                </div>
              </form>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-light-primary font-weight-bold"
                data-dismiss="modal"
                ref={closeModalRef}
              >
                Close
              </button>

              <button
                type="button"
                className="btn btn-primary font-weight-bold"
                onClick={handleSubmit}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
